const createPt310InitState = () => ({
  relationList: [],
});

const createPt310ReqModelState = () => ({});

const state = () => ({
  pt310Init: createPt310InitState(),
  pt310ReqModel: createPt310ReqModelState(),
});

const mutations = {
  RESET_PT310_STATE(currentState) {
    currentState.pt310Init = createPt310InitState();
    currentState.pt310ReqModel = createPt310ReqModelState();
  },
  SET_PT310_INIT(currentState, payload = {}) {
    currentState.pt310Init = payload || {};
  },
  MERGE_PT310_INIT(currentState, payload = {}) {
    currentState.pt310Init = Object.assign({}, currentState.pt310Init, payload);
  },
  SET_PT310_REQ_MODEL(currentState, payload = {}) {
    currentState.pt310ReqModel = payload || {};
  },
  MERGE_PT310_REQ_MODEL(currentState, payload = {}) {
    currentState.pt310ReqModel = Object.assign({}, currentState.pt310ReqModel, payload);
  },
};

const getters = {
  pt310Init: currentState => currentState.pt310Init,
  pt310ReqModel: currentState => currentState.pt310ReqModel,
};

export {
  createPt310InitState,
  createPt310ReqModelState,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
};
